export default __webpack_public_path__ + "static/media/22.a9c9cf7c.jpeg";